module.exports = __webpack_public_path__ + "img/qrCode.991a918a.png";